import ArrowLeft2Icon from "@svg/new-design/arrow-left2";
import LoadingCircleIcon1 from "@svg/new-design/loading-circle1";
import classNames from "classnames";
import { forwardRef } from "react";

interface Props {
  // eslint-disable-next-line no-unused-vars
  onClick?: (e: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => void;
  direction: "left" | "right";
  isLoading?: boolean;
  className: string;
  modeElement?: "button" | "div";
}

const TabNavigationButton = forwardRef<
  HTMLDivElement | HTMLButtonElement,
  Props
>(({ onClick, direction, isLoading, className, modeElement }, ref) => {
  const baseClassName = classNames(
    "rounded-full active:bg-fds-brand-light active:border actvie:border-fds-brand-light h-12 w-12 hover:bg-fds-brand-light shadow-brand-md bg-fds-canvas-secondary flex justify-center items-center",
    className
  );

  const iconContent = isLoading ? (
    <LoadingCircleIcon1 className="h-6 w-6 text-fds-brand animate-spin" />
  ) : (
    <ArrowLeft2Icon
      className={classNames(
        direction === "left" ? "rotate-180" : "",
        "h-6 w-6 text-fds-brand"
      )}
    />
  );

  return modeElement === "div" ? (
    <div
      ref={ref as React.Ref<HTMLDivElement>}
      onClick={onClick}
      className={baseClassName}
    >
      {iconContent}
    </div>
  ) : (
    <button
      ref={ref as React.Ref<HTMLButtonElement>}
      onClick={onClick}
      className={baseClassName}
    >
      {iconContent}
    </button>
  );
});

TabNavigationButton.displayName = "TabNavigationButton";

export default TabNavigationButton;
